import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { get_z3k_object_state, OTTemperaturePreference, } from 'z3k-config';
import { Box, Tooltip, Typography } from '@mui/material';
import Water from 'console/images/heating-circuit/water.svg';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { useZ3KDeviceState } from 'console/shared/hooks/device/z3k';
import { getTemperatureSensor, temperature_from_state, } from 'z3k-parser/lib';
export function getWaterSensor(z3k_config, z3k_state, sensor_id) {
    if (!sensor_id) {
        return { sensor: null, sensor_name: null, temp: null, work_fine: null };
    }
    const sensor = getTemperatureSensor(z3k_config, sensor_id);
    if (!sensor) {
        return { sensor: null, sensor_name: null, temp: null, work_fine: null };
    }
    const sensor_state = get_z3k_object_state(z3k_state, sensor_id);
    if (!sensor_state) {
        return { sensor, sensor_name: sensor.name, temp: null, work_fine: null };
    }
    const temp = temperature_from_state(sensor_state, OTTemperaturePreference.WATER);
    const work_fine = 'sensor_ok' in sensor_state ? sensor_state.sensor_ok : true;
    return {
        sensor,
        sensor_name: sensor.name,
        temp: temp != null && work_fine ? `${temp.toFixed(1)}°` : '??',
        work_fine,
    };
}
export const WaterSensorIndicator = memo(function WaterSensorIndicator(props) {
    const { heating_circuit, z3k_config, show_reserve, is_fail, simple_view, ...rest } = props;
    const z3k_state = useZ3KDeviceState();
    const sensor_id = heating_circuit.water_temp_sensor;
    const { sensor, sensor_name, temp, work_fine } = getWaterSensor(z3k_config, z3k_state, sensor_id);
    if (!sensor) {
        return null;
    }
    const reserve_sensor_id = heating_circuit.water_temp_sensor_reserve;
    const { sensor: reserve_sensor, sensor_name: reserve_sensor_name, temp: reserve_temp, work_fine: reserve_work_fine, } = getWaterSensor(z3k_config, z3k_state, reserve_sensor_id);
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: sensor_name, children: _jsxs(Box, { display: "flex", alignItems: "center", columnGap: "2px", ...rest, children: [!simple_view && (_jsx(ResponsiveIcon, { Icon: Water, fontSize: "0.6em", color: work_fine || is_fail ? 'inherit' : 'disabled' })), _jsx(Typography, { component: "span", fontSize: simple_view ? '0.9em' : '0.6em', fontWeight: simple_view ? '500' : undefined, color: work_fine || is_fail
                                ? simple_view
                                    ? 'text.secondary'
                                    : 'inherit'
                                : 'text.disabled', children: temp })] }) }), show_reserve && reserve_sensor && (_jsx(Tooltip, { title: reserve_sensor_name, children: _jsxs(Box, { display: "flex", alignItems: "center", columnGap: "2px", children: [_jsx(Typography, { component: "span", fontSize: "0.6em", color: reserve_work_fine || is_fail
                                ? 'inherit'
                                : 'text.disabled', children: "R\u00A0" }), _jsx(Typography, { component: "span", fontSize: "0.6em", color: reserve_work_fine || is_fail
                                ? 'inherit'
                                : 'text.disabled', children: reserve_temp })] }) }))] }));
});
